module.exports = __webpack_public_path__ + "img/css-framework5.b9caaed5.png";